import React from 'react';

// Records that the contact agreed to receive text messages (required before any SMS is sent)
export const SmsConsentCheckbox = ({ checked, onChange, testId = 'contact-sms-consent-checkbox' }) => (
  <label className="flex items-start gap-3 p-3 rounded-lg border border-gray-200 bg-gray-50 cursor-pointer">
    <input
      type="checkbox"
      checked={Boolean(checked)}
      onChange={(e) => onChange(e.target.checked)}
      className="mt-0.5 h-4 w-4 text-indigo-600 rounded"
      data-testid={testId}
    />
    <span>
      <span className="block text-sm font-medium text-gray-900">Agreed to receive texts</span>
      <span className="block text-xs text-gray-500">Tick only if this person said they're happy to get SMS updates from you. Texts are never sent without it.</span>
    </span>
  </label>
);

export default SmsConsentCheckbox;
